export default __webpack_public_path__ + "static/media/cross-eye.5cb69589.svg";